import classNames from 'classnames'

import AppDatePicker from './AppDatePicker'
import styles from './AppDatePicker.module.scss'

const AppDateRangePicker = ({
  className,
  disabled = false,
  disableFuture = false,
  endClassName,
  endError = false,
  endHelperText,
  endLabel,
  endName,
  endValue,
  max,
  min,
  onEndChange,
  onStartChange,
  pickerVariant,
  required = false,
  startClassName,
  startError = false,
  startHelperText,
  startLabel,
  startName,
  startValue,
  valueType = 'string'
}) => (
  <div className={classNames(styles.range, className)}>
    <AppDatePicker
      disabled={disabled}
      disableFuture={disableFuture}
      error={startError}
      helperText={startHelperText}
      inline={!startLabel && !startHelperText}
      inputClassName={classNames(startClassName || styles.compactInput)}
      label={startLabel}
      max={max}
      min={min}
      name={startName}
      onChange={onStartChange}
      pickerVariant={pickerVariant}
      required={required}
      value={startValue}
      valueType={valueType}
    />
    <AppDatePicker
      disabled={disabled}
      disableFuture={disableFuture}
      error={endError}
      helperText={endHelperText}
      inline={!endLabel && !endHelperText}
      inputClassName={classNames(endClassName || styles.compactInput)}
      label={endLabel}
      max={max}
      min={min}
      name={endName}
      onChange={onEndChange}
      pickerVariant={pickerVariant}
      required={required}
      value={endValue}
      valueType={valueType}
    />
  </div>
)

export default AppDateRangePicker
